import * as React from "react";
import { forwardRef } from "react";
const SvgCheckSave = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, viewBox: "0 0 12 12", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m9.619 2-5.06 5.06-2.186-2.186L.996 6.251 3.87 9.125l.689.659.689-.659 5.749-5.749Z", className: "s87284de57f0db2c31bda6730229fc528__b" }));
const ForwardRef = forwardRef(SvgCheckSave);
export { ForwardRef as ReactComponent };
